import { call, put, takeEvery } from "redux-saga/effects"
import { GET_CANDIDATE_COMMENT_LIST, GET_CANDIDATE_INTERVIEW_DETAILS, GET_CURRENT_CANDIDATE_STATUS, POST_CANDIDATE_FEEDBACK, POST_CANDIDATE_STAGE, POST_COMMENT_ON_CANDIDATE, UPDATE_CANDIDATE_MAPPING_STATUS } from "./actionTypes"
import {
  candidateMappingStatusUpdateFalied,
  candidateMappingStatusUpdateSuccessfull,
  getCandidateCommentsListFailure,
  getCandidateCommentsListSuccessfull,
  getCandidateInterviewDetailsFailure,
  getCandidateInterviewDetailsSuccess,
  getCurrentCandidateStatusFailure,
  getCurrentCandidateStatusSuccess,
  postCandidateFeedbackFailure,
  postCandidateFeedbackSuccessfull,
  postCandidateStageFailure,
  postCandidateStageSuccess,
  postCommentOnCandidateFailure,
  postCommentOnCandidateSuccessfull
} from "./actions"

import {
  candidateInterviewDetails,
  getCommentsCandidateList,
  postCandidateFeedback,
  postCandidateStageDetails,
  postCommentCandidate,
  postCurrentCandidateStageDetails
} from "../../../../../helpers/fakebackend_helper"

import * as constClass from "../../../../../common/constant/constantURL"



function* getCandidateInterviewDetailsHandler(id){
    try{
        const candidateId=id.payload
        const url=constClass.REST_API_GET_CANDIDATE_INTERVIEW_DETAILS+candidateId
         var responsJSON = yield call(candidateInterviewDetails, url);

     yield put(getCandidateInterviewDetailsSuccess(responsJSON))
    
    }
    catch(error){
      yield put(getCandidateInterviewDetailsFailure(error))
    }

}

function* postCandidateStageHandler(obj){
  try{
    const data=obj.payload
    const url=constClass.REST_API_POST_CANDIDATE_STAGE
    var responsJSON = yield call(postCandidateStageDetails,url,data);

    yield put(postCandidateStageSuccess(responsJSON.message))

  }
  catch(error){
    yield put(postCandidateStageFailure(error))
  }

}

function* getCurrentCandidateStatusHandler(obj){
  try{
    const data=obj.payload
    const url=constClass.REST_API_POST_CURRENT_CANDIDATE_STATUS
    var responsJSON=yield call(postCurrentCandidateStageDetails,url,data)
    yield put(getCurrentCandidateStatusSuccess(responsJSON))

    

  }
  catch(error){
    yield put(getCurrentCandidateStatusFailure(error))
  }

}

function* postCandidateFeedbackHandler(obj){
  try{
    const data=obj.payload
    const url=constClass.REST_API_POST_CANDIDATE_FEEDBACK 
    var responsJSON=yield call(postCandidateFeedback,url,data)
     
    yield put(postCandidateFeedbackSuccessfull(responsJSON))

  }
  catch(error){
    yield put(postCandidateFeedbackFailure(error))
  }

}

function* getCandidateCommentListHandler(id){
    try{
        const candId=id.payload
        const url=constClass.REST_API_GET_CANDIDATE_COMMENT_LIST+candId
    var responsJSON=yield call(getCommentsCandidateList,url)

    yield put(getCandidateCommentsListSuccessfull(responsJSON))


    }
    catch(error){
        yield put(getCandidateCommentsListFailure(error))

    }
}

function* handlePostCommentOnCandidate(obj){
    try{
        const data=obj.payload 
        const url=constClass.REST_API_POST_COMMENT_ON_CANDIDATE
        var responsJSON=yield call(postCommentCandidate,url,data)
        yield put(postCommentOnCandidateSuccessfull(responsJSON))
    }
    catch(error){
        yield put(postCommentOnCandidateFailure(error))
    }

}

function* handleCandidateMappingStatus(obj){
  try{
      const data=obj.payload 
      const url=constClass.REST_API_UPDATE_CANDIDATE_MAPPING_STATUS
      var responsJSON=yield call(postCommentCandidate,url,data)
      yield put(candidateMappingStatusUpdateSuccessfull(responsJSON))


  }
  catch(error){
      yield put(candidateMappingStatusUpdateFalied(error))
  }

}

function* getCandidateInterviewDetailsSaga() {
    yield takeEvery (GET_CANDIDATE_INTERVIEW_DETAILS,getCandidateInterviewDetailsHandler );
    yield takeEvery(POST_CANDIDATE_STAGE,postCandidateStageHandler);
    yield takeEvery(GET_CURRENT_CANDIDATE_STATUS,getCurrentCandidateStatusHandler);
    yield takeEvery(POST_CANDIDATE_FEEDBACK,postCandidateFeedbackHandler);
    yield takeEvery(GET_CANDIDATE_COMMENT_LIST,getCandidateCommentListHandler);
    yield takeEvery(POST_COMMENT_ON_CANDIDATE,handlePostCommentOnCandidate);
    yield takeEvery(UPDATE_CANDIDATE_MAPPING_STATUS,handleCandidateMappingStatus);

    
    
  }
  
  export default getCandidateInterviewDetailsSaga